
















































import { defineComponent, computed } from '@nuxtjs/composition-api'
import uniqueid from 'lodash.uniqueid'

export default defineComponent({
  name: 'BlocksSliderBrands',

  inheritAttrs: false,

  props: {
    data: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    const uid = uniqueid('uid-')

    const banners = computed(() =>
      props.data?.Brands?.map((banner: any) => ({
        id: banner.ID,
        imageUrl: banner.ImageUrl,
        url: '/m/' + banner.Url || banner.AlternateUrl,
        title: banner.Heading || banner.Title,
        text: banner.Text,
        linkTitle: banner.LinkTitle,
      }))
    )
    const swiperOptions = computed(() => {
      return {
        slidesPerView: 2.5,
        spaceBetween: 12,
        // navigation: {
        //   nextEl: `.swiper-${uid} .gw-swiper-button-next`,
        //   prevEl: `.swiper-${uid} .gw-swiper-button-prev`,
        // },
        lazy: {
          loadPrevNext: true,
        },
        breakpoints: {
          481: {
            slidesPerView: 4.5,
            spaceBetween: 32,
          },
          768: {
            slidesPerView: 5.5,
            spaceBetween: 32,
          },
          1024: {
            slidesPerView: 8,
          },
        },
      }
    })

    return {
      uid,
      swiperOptions,
      banners,
    }
  },
})
